import { Result, Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

export function NotFound() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}
    >
      <Result
        status="404"
        title={t('pages.notFound.title')}
        subTitle={t('pages.notFound.subtitle')}
        extra={
          <Button
            type="primary"
            onClick={() => {
              void navigate('/')
            }}
          >
            {t('common.buttons.backToDashboard')}
          </Button>
        }
      />
    </div>
  )
}
